/**
 * The team-meetings baseline every client view shares: team-visible, not a calendar
 * ghost, not archived. Keeps per-client counts and lists identical across apps.
 * Generic over the builder so callers keep their typed query; the cast avoids
 * Supabase's deeply recursive builder types.
 */
export function teamMeetingBaseline(query) {
    const q = query;
    return q.eq('visibility', 'team').eq('is_calendar_ghost', false).is('archived_at', null);
}
